module.exports = __webpack_public_path__ + "static/media/auto-data-validate.95a23855.svg";